import { motion } from 'motion/react';

interface ColorWashEntryProps {
  children: React.ReactNode;
  color?: string;
  threshold?: number;
  delay?: number;
}

export function ColorWashEntry({ color = 'rgba(200, 150, 100, 0.8)', threshold = 0.3, delay = 1.7, children }: ColorWashEntryProps) {
  return (
    <motion.div className="relative">
      {/* Wash overlay that wipes out */}
      <motion.div
        initial={{ clipPath: 'inset(0 0 0 0)' }}
        whileInView={{ clipPath: 'inset(0 0 100% 0)' }}
        viewport={{ once: true, amount: threshold }}
        transition={{ duration: 1.2, delay: delay * 0.4, ease: 'easeOut' }}
        className="absolute inset-0 z-10 pointer-events-none"
        style={{ backgroundColor: color }}
      />

      {/* Content fades in after background artwork display */}
      <motion.div
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: threshold }}
        transition={{ duration: 1.2, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
}
